import { Directive, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormFieldError } from './uix-forms.utils';
import { UntypedFormGroup } from '@angular/forms';
import { MatFormFieldAppearance } from '@angular/material/form-field';
import { isEqual } from 'lodash-es';

@Directive()
export abstract class FormField implements OnChanges {
  @Input()
  label: string;

  @Input()
  field: string;

  @Input()
  errors: FormFieldError[] = [];

  @Input()
  formGroup: UntypedFormGroup;

  @Input()
  resetValue: unknown = '';

  @Input()
  clearable = false;

  @Input()
  readonly = false;

  @Input()
  appearance: MatFormFieldAppearance = 'outline';

  @Output()
  valueCleared: EventEmitter<unknown> = new EventEmitter<unknown>();

  @Input()
  mandatory: boolean;

  @Input()
  focusAndSelect: boolean;

  @Input()
  icon: string;

  @Input()
  hint: string;

  @Output()
  enterPressed: EventEmitter<Event> = new EventEmitter<Event>();

  @Output()
  escapePressed: EventEmitter<Event> = new EventEmitter<Event>();

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.formGroup.controls[this.field]) {
      console.error(`Missing form field`, this.field);
    }

    if (changes.errors?.currentValue) {
      changes.errors.currentValue.forEach((e: FormFieldError) => {
        if (e.error === 'required') {
          this.mandatory = true;
        }
      });
    }
  }

  keydownEnter(e: Event): void {
    e.preventDefault();
    this.enterPressed.next(e);
  }

  keydownEscape(e: Event): void {
    this.escapePressed.next(e);
  }

  resetControlValue($event?: Event): void {
    this.valueCleared.next(this.resetValue);
    this.formGroup.controls[this.field].reset(this.resetValue);
    this.formGroup.markAsDirty();
    $event?.stopPropagation();
    this.formGroup.controls[this.field].markAsTouched();
    this.formGroup.controls[this.field].markAsDirty();
    this.formGroup.controls[this.field].updateValueAndValidity();
  }

  shouldDisplayClearBtn(): boolean {
    const { value, disabled } = this.formGroup.controls[this.field];
    return value && !isEqual(value, this.resetValue) && value !== -1 && this.clearable && !disabled;
  }
}
